<script setup lang="ts">
import { ref } from "vue";

const item = ref(null);
defineExpose({
  item,
});
</script>
<template>
  <svg ref="item" width="20" height="20" viewBox="0 0 20 20" fill="none" class="option-icon"
    xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.85" fill-rule="evenodd" clip-rule="evenodd"
      d="M11.25 4C11.25 4.69036 10.6904 5.25 10 5.25C9.30964 5.25 8.75 4.69036 8.75 4C8.75 3.30964 9.30964 2.75 10 2.75C10.6904 2.75 11.25 3.30964 11.25 4ZM11.25 10C11.25 10.6904 10.6904 11.25 10 11.25C9.30964 11.25 8.75 10.6904 8.75 10C8.75 9.30964 9.30964 8.75 10 8.75C10.6904 8.75 11.25 9.30964 11.25 10ZM10 17.25C10.6904 17.25 11.25 16.6904 11.25 16C11.25 15.3096 10.6904 14.75 10 14.75C9.30964 14.75 8.75 15.3096 8.75 16C8.75 16.6904 9.30964 17.25 10 17.25Z"
      fill="white" />
  </svg>
</template>
<style scoped>
.option-icon {
  flex-shrink: 0;
}
</style>
